'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../../../styleInject.js');

var css_248z = ".ItemCard-module_item__Zb3aT{justify-items:center;margin:0;padding:0}@container (min-width: 300px){.ItemCard-module_item__Zb3aT{grid-template-columns:1fr 1fr;justify-items:start}}";
var styles = {"item":"ItemCard-module_item__Zb3aT"};
styleInject["default"](css_248z, 'cd05af0b-a38c-42dd-9dca-5011687c04f5');

exports["default"] = styles;
